import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable'
import DashboardLayout from '../layout/Dashboard';
import { Navigate } from 'react-router';
import RequireVerified from '../auth/RequireVerified';
import AdminRoute from '../auth/AdminRoute';

// main
const MainPage = Loadable(lazy(() => import('pages/main/MainPage')));

// admin
const AdminLayout = Loadable(lazy(() => import('pages/admin/AdminLayout')));
const AdminOverviewPage = Loadable(lazy(() => import('pages/admin/AdminOverviewPage')));
const AdminAppointmentsPage = Loadable(lazy(() => import('pages/admin/AdminAppointmentsPage')));
const AdminMedicalPage = Loadable(lazy(() => import('pages/admin/AdminMedicalPage')));
const AdminTechPage = Loadable(lazy(() => import('pages/admin/AdminTechPage')));
const AdminUsersPage = Loadable(lazy(() => import('pages/admin/AdminUsersPage')));

// make appointment 
const MakeAppointmentPage = Loadable(lazy(() => import('pages/makeAppointment/MakeAppointmentPage')));
const AppointmentByDirectionPage = Loadable(lazy(() => import('pages/makeAppointment/children/AppointmentByDirectionPage')));
const FreeAppointmentPage = Loadable(lazy(() => import('pages/makeAppointment/children/FreeAppointmentPage')));

// medcard 
const MedCardPage = Loadable(lazy(() => import('pages/medCard/MedCardPage')));
const AnalysisResultPage = Loadable(lazy(() => import('pages/medCard/children/AnalysisResultPage')));
const HospitalizationsPage = Loadable(lazy(() => import('pages/medCard/children/HospitalizationPage')));  
const ResearchPage = Loadable(lazy(() => import('pages/medCard/children/ResearchPage')))
const ExaminationPage = Loadable(lazy(() => import('pages/medCard/children/ExaminationPage')))
const DirectionPage = Loadable(lazy(() => import('pages/medCard/children/DirectionPage')))
const RecipePage = Loadable(lazy(() => import('pages/medCard/children/RecipePage')))
const RecommendationsPage = Loadable(lazy(() => import('pages/medCard/children/RecommendationsPage')))
// Раздел "Заключения ВЭК" перенесён из медкарты в карту профосмотра раздела ВЭК
// (/medicalCommission/:year/:cardId/conclusions), см. ниже

// myAppointments
const MyAppointmentsPage = Loadable(lazy(() => import('pages/myAppointments/MyAppointmentsPage')));
const AppointmentDetailsPage = Loadable(lazy(() => import('pages/myAppointments/children/AppointmentDetailsPage')))

// promotions
const PromotionsPage = Loadable(lazy(() => import('pages/promotions/PromotionsPage')));
const DetailsPromotionsPage = Loadable(lazy(() => import('pages/promotions/children/DetailsPromotionsPage')));

// contacts 
const ContantPage = Loadable(lazy(() => import('pages/contacts/ContactsPage')));
const ClinicPage = Loadable(lazy(() => import('pages/contacts/children/ClinicPage')));

// cardDoctor
const CardDoctorPage = Loadable(lazy(() => import('pages/cardDoctor/cardDoctorPage')));

// profile
const Profile = Loadable(lazy(() => import('pages/profile/profilePage')));

// DetailsAnalysisResPage
const Details = Loadable(lazy(() => import('pages/medCard/children/DetailsAnalysisResPage')));

// Hospitalizations (Биржа заявок)
const ExchangeHospitalizationsPage = Loadable(lazy(() => import('pages/hospitalizations/HospitalizationsPage')));
const HospitalizationsDetailsPage = Loadable(lazy(() => import('pages/hospitalizations/children/HospitalizationsDetailsPage')));

// MedicalCommission (ВЭК)
const MedicalCommissionPage = Loadable(lazy(() => import('pages/medicalCommission/MedicalCommissionPage')));
const VekYearCardsPage = Loadable(lazy(() => import('pages/medicalCommission/children/VekYearCardsPage')));
const VekCardPage = Loadable(lazy(() => import('pages/medicalCommission/children/VekCardPage')));
const VekCardDoctorsPage = Loadable(lazy(() => import('pages/medicalCommission/children/VekCardDoctorsPage')));
const VekCardResearchesPage = Loadable(lazy(() => import('pages/medicalCommission/children/VekCardResearchesPage')));
const VekCardConclusionsPage = Loadable(lazy(() => import('pages/medicalCommission/children/VekCardConclusionsPage')));

// QR-код
const QrCodePage = Loadable(lazy(() => import('pages/qrCode/QrCodePage')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <RequireVerified>
      <DashboardLayout/>
    </RequireVerified>
  ),
  children: [
    {
      index: true,
      element: <Navigate to='/main' replace/>
    },
    {
      path: '/main',
      element: <MainPage />
    },
    {
      path: '/makeAppointment',
      element: <MakeAppointmentPage />,
      children: [
        {
          path: '/makeAppointment/direction',
          element: <AppointmentByDirectionPage/>
        },
        {
          path: '/makeAppointment/free',
          element: <FreeAppointmentPage/>
        }
      ]
    },
    {
      path: '/medCard',
      element: <MedCardPage />,
      children: [
        {
          path: '/medCard/analysisResults',
          element: <AnalysisResultPage />
        },
        {
          path: '/medCard/hospitalizations',
          element: <HospitalizationsPage />
        },
        {
          path: '/medCard/researches',
          element: <ResearchPage /> 
        },
        {
          path: '/medCard/examinations',
          element: <ExaminationPage/>
        },
        {
          path: '/medCard/directions',
          element: <DirectionPage />
        },
        {
          path: '/medCard/recipes',
          element: <RecipePage />
        },
        {
          path: '/medCard/analysisResults/DetailsAnalysisResPage/:id',
          element: <Details />
        },
        {
          path: '/medCard/recommendations',
          element: <RecommendationsPage />
        },
      ]
    },
    {
      path: '/myAppointments',
      element: <MyAppointmentsPage />,
      children: [
        {
          path: '/myAppointments/:id',
          element: <AppointmentDetailsPage />
        }
      ]
    },
    {
      path: '/promotions',
      element: <PromotionsPage />,
      children: [
        {
          path: '/promotions/:id',
          element: <DetailsPromotionsPage />
        }
      ]
    },
    {
      path: '/contacts',
      element: <ContantPage />,
      children: [
        {
          path: '/contacts/:id',
          element: <ClinicPage />
        }
      ]
    },
    {
      path: '/cardDoctor/:id',
      element: <CardDoctorPage />
    },
    {
      path: '/profile',
      element: <Profile />
    },
    {
      path: '/hospitalizations',
      element: <ExchangeHospitalizationsPage />,
      children: [
        {
          path: '/hospitalizations/:id',
          element: <HospitalizationsDetailsPage />
        }
      ]
    },
    {
      // ВЭК: годы -> карты профосмотра года -> карта (три раздела) -> раздел карты
      path: '/medicalCommission',
      element: <MedicalCommissionPage />,
      children: [
        {
          path: '/medicalCommission/:year',
          element: <VekYearCardsPage />
        },
        {
          path: '/medicalCommission/:year/:cardId',
          element: <VekCardPage />,
          children: [
            {
              path: '/medicalCommission/:year/:cardId/doctors',
              element: <VekCardDoctorsPage />
            },
            {
              path: '/medicalCommission/:year/:cardId/researches',
              element: <VekCardResearchesPage />
            },
            {
              path: '/medicalCommission/:year/:cardId/conclusions',
              element: <VekCardConclusionsPage />
            }
          ]
        }
      ]
    },
    {
      path: '/qrCode',
      element: <QrCodePage />
    },
    {
      element: <AdminRoute />,
      children: [
        {
          path: '/admin',
          element: <AdminLayout />,
          children: [
            { path: '/admin', element: <AdminOverviewPage /> },
            { path: '/admin/users', element: <AdminUsersPage /> },
            { path: '/admin/appointments', element: <AdminAppointmentsPage /> },
            { path: '/admin/medical', element: <AdminMedicalPage /> },
            { path: '/admin/tech', element: <AdminTechPage /> },
          ]
        },
      ],
    },
  ]
};

export default MainRoutes;